module.exports = __webpack_public_path__ + "static/media/Team 22 Upzee Interchange Logo - Ankit Singh.edf8146a.png";